<template>
  <el-upload
    action
    :on-remove="handleRemove"
    :http-request="upload"
    :file-list="explainFileList"
  >
    <el-button size="small" type="primary">{{ buttonText }}</el-button>
  </el-upload>
</template>

<script>
import { uploadFile } from "@/api/common";
export default {
  props: {
    lookUrl: {
      type: String
    },
    saveUrl: {
      type: String
    },
    buttonText: {
      type: String,
      default: "点击上传"
    }
  },

  data() {
    return {
      fileList: [],
      // fileArray: [],
      explainFileList: []
    };
  },

  computed: {
    Authorization() {
      return sessionStorage.getItem("token");
    }
  },
  watch: {
    lookUrl: {
      handler: function(newVal, oldVal) {
        if (newVal != oldVal) {
          this.updateExplainFileList();
        }
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    updateExplainFileList() {
      if (this.lookUrl) {
        let name = this.lookUrl.substring(this.lookUrl.lastIndexOf("/") + 1);

        name = name.split("?")[0];

        this.explainFileList.push({
          name,
          url: this.lookUrl
        });
      }
    },
    handleRemove() {
      this.explainImgList = [];
    },
    async upload(file) {
      this.explainFileList = [];
      const form = new FormData();

      form.append("files", file.file);

      form.append("Authorization", this.Authorization);

      try {
        this.$modal.loading("正在上传文件，请稍候...");

        const res = await uploadFile(form);

        if (res.code === 200) {
          this.$emit("update:lookUrl", res.data.fileLook[0]);
          this.$emit("update:saveUrl", res.data.fileAddr[0]);
          this.$emit("success", {
            url: res.data.fileAddr[0],
            name: file.file.name,
            type: file.file.type
          });
          this.$modal.closeLoading();
        } else {
          this.$modal.closeLoading();
          this.$modal.msgWarning('上传文件失败，请重试');
        }
      } catch(err) {
        console.log(err);
        this.$modal.closeLoading();
        this.$modal.msgWarning('上传文件失败，请重试');
      }
    },
    clear() {
      this.explainFileList = [];
    }
  }
};
</script>

<style></style>
